import React from 'react'
import { Link } from 'react-router'
import PieChart from './PieChart'

//const title = Object.assign({fontFamily: 'Oswald'}, {fontSize: '32'},
                            //{color: '#65737e'})
const title = Object.assign({fontFamily: 'Oswald'}, {fontSize: '32'})


const sent_style = Object.assign({fontFamily: 'Oswald'}, {fontSize: '32'},
                            {color: '#ab5b5b'})
const rec_style = Object.assign({fontFamily: 'Oswald'}, {fontSize: '32'},
                            {color: '#005b96'})

const sentBG = '#ab5b5b';
const recBG = '#005b96';

const Result = React.createClass({
  renderLine(color, text, item) {
    return (
      <tr style={{color: color }}>
        <td><b>{text}{item.label}</b></td>
        <td><b>{Number(item.value).toFixed(2)}</b></td>
      </tr>
    )
  },
  renderTitle() {
    console.log(this.props.trade)
    return (
      <h2 className="text-center" style={title}>
        <span style={sent_style}>{this.props.trade.sentValue.toFixed(2)}</span> vs <span style={rec_style}>{this.props.trade.recValue.toFixed(2)}</span>
      </h2>
    )
  },
  tableBody(picks, players, style) {
    if (picks.length > 0 | players.length > 0) {
      return (
        <tbody>
          {players.map(this.renderLine.bind(null, style, ''))}
          {picks.map(this.renderLine.bind(null, style, 'Pick '))}
        </tbody>
      )
    }
    else {
      return (
        <tr style={{color: style}}>
          <td><b>--</b></td>
          <td><b>--</b></td>
        </tr>
      )
    }
  },
  render () {
    return (
      <div>
        <strong>{this.renderTitle()}</strong>
          <table className="table">
            <thead>
              <tr>
                <th>Sent:</th>
                <th>Value</th>
              </tr>
            </thead>
              {this.tableBody(this.props.trade.pickSent, this.props.trade.playerSent, sentBG)}
            <br/>
            <thead>
              <tr>
                <th>Recieved:</th>
                <th>Value</th>
              </tr>
            </thead>
              {this.tableBody(this.props.trade.pickRec, this.props.trade.playerRec, recBG)}
          </table>
      </div>
    )
  }
});

export default Result;




// WEBPACK FOOTER //
// ./src/components/Result.js